module.exports = __webpack_public_path__ + "img/1303508917.473909ac.jpg";